import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {GoogleTagService} from '../../../../../data/networking/services/shared/google-tag/google-tag.service';
import {PageEvent} from '../../../event-listeners/event-page/event-page.event';

@Component({
  selector: 'app-voice-search',
  templateUrl: './voice-search.component.html',
  styleUrls: ['./voice-search.component.scss'],
})
export class VoiceSearchComponent implements OnInit, OnChanges {
  @Input() searchHomeR = false;
  @Input() fixedBoxSearch = false;
  @Input() screenSize;
  @Output() voiceSearch = new EventEmitter();
  src;
  onSearching = false;
  showContent = false;
  isBrowser;
  constructor(private gtmService: GoogleTagService,
              private eventPage: PageEvent,
              @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
    this.getAllServices();
    }

  ngOnInit() {
    this.changeSrc();
    if (this.isBrowser && ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
      window.SpeechRecognition = (window as any).webkitSpeechRecognition || window.SpeechRecognition;
      let finalTranscript = '';
      const recognition = new window.SpeechRecognition();
      recognition.interimResults = true;
      recognition.maxAlternatives = 10;
      recognition.continuous = true;
      recognition.lang = 'es-CO';
      const micButton: any = document.querySelectorAll('.header-voice-search');
      recognition.onresult = event => {
        for (let i = event.resultIndex, len = event.results?.length; i < len; i++) {
          const {transcript} = event.results[i][0];
          if (event.results[i].isFinal) {
            finalTranscript = transcript;
          }
        }

        this.gtmService.voiceSearchAlgolia(finalTranscript);
        this.voiceSearch.emit(finalTranscript);
      };

      const startVoiceRecognition = event => {
        event.preventDefault();
        recognition.start();
      };

      const stopVoiceRecognition = event => {
        recognition.stop();
      };

      const timer = event => {
        setTimeout(() => {
          if (this.onSearching) {
            this.onSearching = false;
            stopVoiceRecognition(event);
          }
        }, 4000);
      };

      if (micButton) {
        for (let i = 0, len = micButton.length; i < len; i++) {
          micButton[i].oncontextmenu = event => {
            event.preventDefault();
          };

          micButton[i].addEventListener('mousedown', event => {
            this.onSearching = !this.onSearching;

            if (this.onSearching) {
              startVoiceRecognition(event);
              timer(event);
            } else {
              stopVoiceRecognition(event);
            }
          });
        }
      }
    }
  }

  changeSrc() {
    this.src = 'assets/svg/icon-microphone-blue.svg';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fixedBoxSearch) {
      this.fixedBoxSearch = changes.fixedBoxSearch.currentValue;
    }

    if (changes.searchHomeR) {
      this.searchHomeR = changes.searchHomeR.currentValue;
    }

    if (changes.screenSize) {
      this.screenSize = changes.screenSize.currentValue;
    }

    this.changeSrc();
  }

  getAllServices() {
    this.showContent = navigator.userAgent.search('Windows') >= 0 || navigator.userAgent.search('Android') >= 0;
  }

}
